"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleFooter = exports.StyleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleFooter = exports.StyleFooter = _styledComponents.default.footer.withConfig({
  displayName: "StyleFooter",
  componentId: "sc-19ocze5-0"
})(["position:relative;border-top:1px solid ", ";background-color:#EDECF2;font-size:10px;line-height:15px;@media ", "{padding:16px 24px;}"], (0, _color.default)('gray-4'), _responsive.default.lg);
const StyleContainer = exports.StyleContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleContainer",
  componentId: "sc-19ocze5-1"
})(["display:flex;justify-content:space-between;align-items:center;flex-direction:column-reverse;> div:first-of-type{margin-top:12px;padding-bottom:16px;}@media ", "{> div:first-of-type{margin-top:0;padding-bottom:0;}flex-direction:row;}"], _responsive.default.lg);